const SCHEME = {
  appDomain: 'APP_DOMAIN',
  appProtocol: 'APP_PROTOCOL',
  apiRoot: 'API_ROOT',
  defaultLang: 'DEFAULT_LANG',
  stripeApiKey: 'STRIPE_KEY',
  stripeLogoUrl: 'STRIPE_LOGO_IMAGE_URL',
  minimalBookingOffset: 'MIN_BOOKING_OFFSET',
  enableTimeline: 'ENABLE_TIMELINE',
  enableSiteIntegrations: 'ENABLE_SITE_INTEGRATIONS',
  GOOGLE_MAP_API_KEY: 'GOOGLE_MAP_API_KEY',
  FACEBOOK_APP_ID: 'FACEBOOK_APP_ID',
  TRAVEL_PAYOUTS_HOSTNAME: 'TRAVEL_PAYOUTS_HOSTNAME',
  server: {
    host: 'SERVER_HOST',
    port: 'SERVER_PORT',
    apiHost: 'SERVER_API_HOST',
    apiPort: 'SERVER_API_PORT',
    apiProtocol: 'SERVER_API_PROTOCOL',
    resourceDir: 'SERVER_RESOURCE_DIR'
  }
};

function buildConfig(scheme) {
  const config = {};

  Object.keys(scheme).forEach(key => {
    if (typeof scheme[key] === 'object') {
      config[key] = buildConfig(scheme[key]);
    } else if (typeof scheme[key] === 'string') {
      const envKey = scheme[key];
      if (typeof process.env[envKey] !== 'undefined') {
        config[key] = process.env[envKey];
      }
    }
  });

  return config;
}

let config;
if (process.env.REACT_APP_IS_CLIENT) {
  config = window.__config;
} else {
  config = buildConfig(SCHEME);
}

export default config;



// WEBPACK FOOTER //
// ./src/config/local.js